var $ = require('jquery');
var TorsoService = require('backbone-torso/modules/ServiceCell');
var patientRegistrationExtService = require('./../urls').patientRegistrationExtService;
var TorsoNestedModel = require('backbone-torso/modules/NestedModel');

/**
 * Service that manages portal patient registration.
 *
 * @class patientRegistrationService
 * @constructor
 */
module.exports = new (TorsoService.extend({

  /**
   * Authenticates the patient, verifies if the patient is eligible for portal signup.
   * @method authenticate
   */
  authenticate: function(patientSignupFormModel) {
    var patientRegistrationModel = new TorsoNestedModel();
    patientSignupFormModel.setTrackedModel('patientRegistrationModel', patientRegistrationModel, false);
    patientSignupFormModel.push();
    patientSignupFormModel.unsetTrackedModel('patientRegistrationModel', patientRegistrationModel);

    return $.ajax({
      method: 'POST',
      url: patientRegistrationExtService,
      data: JSON.stringify(patientRegistrationModel.toJSON()),
      contentType: 'application/json;charset=utf-8'
    });
  },

  /**
   * Signs up the patient to portal.
   * @method signup
   */
  signup: function(patientSignupFormModel) {
    var patientRegistrationModel = new TorsoNestedModel();
    patientSignupFormModel.setTrackedModel('patientRegistrationModel', patientRegistrationModel, false);
    patientSignupFormModel.push();
    patientSignupFormModel.unsetTrackedModel('patientRegistrationModel', patientRegistrationModel);

    return $.ajax({
      method: 'PUT',
      url: patientRegistrationExtService,
      data: JSON.stringify(patientRegistrationModel.toJSON()),
      contentType: 'application/json;charset=utf-8'
    });
  }
}))();
